import { render, staticRenderFns } from "./DepartmentVueSelect_1.vue?vue&type=template&id=085f4d30&scoped=true&"
import script from "./DepartmentVueSelect_1.vue?vue&type=script&lang=js&"
export * from "./DepartmentVueSelect_1.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentVueSelect_1.vue?vue&type=style&index=0&id=085f4d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f4d30",
  null
  
)

export default component.exports